export const typeOfValveOptions = [
    {value: 'SOLENOID_PLASTIC', label: 'Plastic solenoid'},
    {value: 'SOLENOID_METAL', label: 'Metal solenoid'},
    {value: 'BALL_VALVE', label: 'Ball valve'},
    {value: 'BUTTERFLY_VALVE', label: 'Butterfly valve'}
];
